import React, { memo } from "react";
import PropTypes from "prop-types";
import warningIcon from "iconsTwoColors/cx/Ic_Warning.svg";
import { Variants } from "@dhl-official/stencil-library";
// eslint-disable-next-line import/no-cycle
import ContentModal from "../ContentModal";
import Icon from "../../Icons/Icon";
import {
  Content,
  ButtonsContainer,
  StyledButton,
  StyledWarningIconWrapper,
  StyledContentWrapper,
  StyledHeadline,
} from "./styled";

const RetryModal = ({
  cancelButtonLabel,
  children,
  closeButtonLabel,
  headline,
  hideCloseIcon,
  isRetrying,
  onClose,
  onRetry,
  retryButtonLabel,
  subHeadline,
  ...otherProps
}) => (
  <ContentModal
    closeButtonAriaLabel={closeButtonLabel}
    contentAriaLabel={`${headline} ${subHeadline}`}
    hideCloseIcon={hideCloseIcon}
    {...otherProps}
    smallCenteredModal
    onClose={onClose}
  >
    <Content>
      <StyledWarningIconWrapper>
        <Icon
          fillColor="var(--dui-color-red-500)"
          icon={warningIcon}
          size="inbetweenLarge"
          useAs="decorative"
        />
      </StyledWarningIconWrapper>

      <StyledContentWrapper>
        <StyledHeadline
          dataTestid="retry-modal-headline"
          noMargin
          priority={3}
          weight="800"
        >
          {headline}
          <span>{subHeadline}</span>
        </StyledHeadline>

        {children}

        <ButtonsContainer>
          <StyledButton
            className="automation-errorModal-retry-button"
            dataTestid="retry-modal-retry-button"
            isDisabled={isRetrying}
            name="button"
            clickEvent={onRetry}
            type="submit"
          >
            {retryButtonLabel}
          </StyledButton>
          <StyledButton
            variant={Variants.outline}
            className="automation-errorModal-close-button"
            dataTestid="retry-modal-cancel-button"
            name="button"
            clickEvent={onClose}
            type="submit"
          >
            {cancelButtonLabel}
          </StyledButton>
        </ButtonsContainer>
      </StyledContentWrapper>
    </Content>
  </ContentModal>
);

RetryModal.propTypes = {
  cancelButtonLabel: PropTypes.node.isRequired,
  children: PropTypes.node,
  closeButtonLabel: PropTypes.node.isRequired,
  headline: PropTypes.node.isRequired,
  hideCloseIcon: PropTypes.bool,
  isRetrying: PropTypes.bool,
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
  retryButtonLabel: PropTypes.node.isRequired,
  subHeadline: PropTypes.node.isRequired,
};

RetryModal.defaultProps = {
  children: undefined,
  hideCloseIcon: true,
  isRetrying: false,
  onClose: Function.prototype,
  onRetry: Function.prototype,
};

export default memo(RetryModal);
